import clsx from 'clsx'
import React, { PropsWithChildren } from 'react'
import { Loader } from '../loader/Loader'
import styles from './styles/ButtonLink.module.scss'

export type ButtonLinkProps = PropsWithChildren & {
  underline?: boolean
  disabled?: boolean
  isLoading?: boolean
  className?: string
  highlight?: boolean
  role?: string
  onClick?: (e) => void
}

export const ButtonLink = React.forwardRef<HTMLButtonElement, ButtonLinkProps>((props, ref) => {
  const { disabled, isLoading, underline, className, highlight, onClick, children, ...rest } = props

  const showLoader = isLoading !== undefined

  const handleClick = e => {
    onClick?.(e)
  }

  return (
    <button
      ref={ref}
      disabled={disabled || isLoading}
      onClick={handleClick}
      type="button"
      data-render-variant="link"
      className={clsx(
        styles.buttonLink,
        underline && !disabled && styles.underline,
        highlight && styles.highlight,
        className
      )}
      {...rest}
    >
      {showLoader && <Loader open={Boolean(isLoading)} variant="dark" />}
      {children}
    </button>
  )
})
